import type { ReactNode } from "react";
import logoFull from "../../assets/logo-full.png";

type Props = {
  /** Classes Tailwind aplicadas à imagem (altura, largura máx., alinhamento) */
  className?: string;
};

export function AuthBrand({
  className = "h-12 w-auto max-w-[min(100%,280px)] object-contain object-center",
}: Props) {
  return (
    <div className="flex justify-center">
      <img
        src={logoFull}
        alt="Aprender e Capacitar Brasil"
        className={className}
        width={560}
        height={240}
        decoding="async"
        loading="eager"
      />
    </div>
  );
}

/** Logo mobile — cartão “flutuante” alinhado ao design system */
export function AuthMobileLogoShell({ children }: { children: ReactNode }) {
  return (
    <div className="mb-5 flex justify-center lg:hidden">
      <div className="rounded-2xl border border-zinc-200 px-5 py-3.5 shadow-[0_20px_40px_-12px_rgba(0,0,0,0.35)] ring-1 ring-white">
        {children}
      </div>
    </div>
  );
}
